'use strict'

module.exports = require('./utils/interpolate').interpolateArray(require('./hex/plasma.json'))



//////////////////
// WEBPACK FOOTER
// ./~/scale-color-perceptual/plasma.js
// module id = 851
// module chunks = 0